<template>
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
            <div class="d-flex align-items-center">
               <a class="link-dark text-truncate d-flex align-items-center gap-2"  >
                  
                  <div>
                    <h2 class="text-white text-center">Laundry Master</h2>
                  </div>
               
               </a>
         
            </div>
         </div>
         <!--start------------------------------------------------------- body----------------------------------------------------------------------------->

         <!-- Body -->
        <div class="container d-flex flex-column  mt-5 align-items-center flex-grow-1">
            <div class="card p-2 shadow" style="width: 100%; max-width: 400px;">
                <h3 class="text-center mb-3">Add Laundry Details</h3>
                
                <div>
                    <div class="mb-1">
                     <label for="name" class="form-label">Laundry Name</label>
                     <input type="text" class="form-control"
                        id="name" placeholder="name" v-model="laundry.name">
                  </div>
      
                  <div class="mb-1">
                     <label for="address" class="form-label"> Laundry Address</label>
                     <input type="text" class="form-control"
                        id="address" placeholder="address" v-model="laundry.address">
                  </div>
      
                  <div class="mb-1">
                     <label for="contact" class="form-label">Laundry Contact</label>
                     <input type="number" class="form-control"
                        id="contact" placeholder="contact" v-model="laundry.contact">
                  </div>
      
                  <div class="mb-1">
                    <label for="footermessage" class="form-label">Footer Message (Terms/Note/etc)</label>
                    <input type="text" class="form-control"
                       id="text" placeholder="message" v-model="laundry.footermessage">
                 </div>
      
                  <div class="mb-1">
                     <label  class="form-label" for="img_upload_here">Image<br>
                     <input type="file" id="img_upload_here" style="display: none;" @change="eventFileUpload" class="form-control" required>
                      <img src="../assets/upload_image.jpg" style="height: 50px; "/><br>
                      <!-- <img v-if="!imagePreview" :src="$asset_path+'addlaundry/' +laundrydetails.img" alt="Order Image" height="150px"> -->
                     <img v-if="imagePreview" :src="imagePreview" style="max-width: 150px; border: 2px solid #000; border-radius: 5px;">
                     </label>
                 </div>
              </div>
              <button class="btn btn-primary w-100" @click="registerlaundry">Register</button>
              
               <!-- <div class="text-center mt-3">
                    <p>Not registered?<router-link :to="'/register'">Create an account</router-link></p>

                </div>  -->
            </div>
        </div>

        <!-- end ---------------------------------------------------------body----------------------------------------------------------------------------->










   

         <!-- footer -->
         <div class="footer bg-white shadow mt-auto border-top">
            <div class="d-flex align-items-center justify-content-center py-1">
                <!--<p style="text-align: center; color: white; margin: 0;">Designed And Developed by DK Techno's</p>-->
            </div>
        </div>
      </div>
</template>
<style>
.weather-container {
  text-align: center;
    font-family: Arial, sans-serif;
    padding: 4px 20px;
    background: #f4f4f4;
    margin: auto;
    border-radius: 10px;
}
.bg_card{
  background: #ededec;
    margin: 10px 0px;
    padding-bottom: 10px;
}
.custom-btn {
    background: linear-gradient(328deg, #ff0000, #000199);
    border: none; /* Remove Bootstrap's default border */
    color: white; /* Ensure text is readable */
}

</style>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'HomeView',
  components: { 
  },
  mounted() {
    
     
},
  data() {
    return {
      loading:false,
      error:null,
      imagePreview: null,  

      laundry:{
               id:'',
               name:'',
               address:'',
               contact:'',
               footermessage:''
            }
         
        
    }
  },
  methods:{
    

    

      eventFileUpload(event) {
                this.laundry.img = event.target.files[0]; // Store the selected file
                const file = event.target.files[0]; // Correctly define 'file'
                    if (file) {
                      this.laundry.file = file; // Store the selected file
                      this.imagePreview = URL.createObjectURL(file); // Create image preview
                    }
            },


      registerlaundry() {
        this.loading = true;
        this.error = null;
           var self=this;
            if(!self.laundry.name){
                self.$swal.fire("Please Enter Laundry Name");
                return;
            }
              if(!self.laundry.img || !self.imagePreview){
                self.$swal.fire("Please Select Laundry Logo");
                return;
            }
        
        try {
            axios.post("registernewlaundry",self.laundry,{
                     headers: {
              'Content-Type': 'multipart/form-data'
                  }
                }).then((response) => {
              
              
              
              self.$swal.fire(response.data.message);
              if(response.data.success ==1){ 
                self.$router.push('/home');
                
              }
       
              // $sw
              self.verified = true;
              self. otpverified=true;
          }).then(() => {
            
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 







  }
}
</script>
